import { BrowserConfig } from '@bloomays-lib/types.shared';

const config = (): Omit<BrowserConfig, 'auth0'> => {
  const TALENTS_API = import.meta.env.VITE_TALENTS_API as string;
  const BLOOMERS_API = import.meta.env.VITE_BLOOMERS_API as string;
  const DEBUG_MODE = (import.meta.env.VITE_DEBUG_MODE as boolean) || false;

  if (!TALENTS_API) {
    console.error('Missing environment variables for APP client');
  }
  return {
    url: {
      talentAPI: `${TALENTS_API}graphql`,
      bloomersAPI: BLOOMERS_API,
    },
    service: 'app.client',
    debug: DEBUG_MODE,
    env:
      import.meta.env.VITE_ENV === 'production' ||
      import.meta.env.VITE_ENV === 'staging' ||
      import.meta.env.VITE_ENV === 'test'
        ? import.meta.env.VITE_ENV
        : 'development',
    release: import.meta.env.VITE_RELEASE || 'localhost',
    logger: {
      datadog: {
        apiKey: import.meta.env.VITE_APP_CLIENT_DATADOG_API_KEY,
      },
      level: import.meta.env.VITE_LOGGER_LEVEL || 'info',
    },
    monitoring: {
      allowedTracingUrls: [import.meta.env.VITE_BLOOMERS_API, import.meta.env.VITE_TALENTS_API],
      datadog: {
        apiKey: import.meta.env.VITE_APP_CLIENT_DATADOG_API_KEY,
        rumAppId: import.meta.env.VITE_APP_CLIENT_RUM_APP_ID,
      },
      sentry: {
        dsn: import.meta.env.VITE_APP_CLIENT_SENTRY_DSN,
      },
    },
  };
};

export default config;
